/**
 * =============================================================================
 * ListPageKpis — Grid horizontal de KPI cards para listagem.
 *
 * Container padronizado: `grid grid-cols-2 lg:grid-cols-4 gap-3 px-4 py-3 border-b`.
 * Use em conjunto com <KpiCard />.
 *
 * @version 1.0.0
 * RELEASE: 2026-10-16 v1.1.0 - Removido o separador inferior (padrão da listagem de Tarefas).
 * RELEASE: 2026-04-25 v1.0.0 - Criação do helper de KPIs padronizado.
 * =============================================================================
 */
import React from 'react';
import { cn } from '@/lib/utils';

interface ListPageKpisProps {
  children: React.ReactNode;
  /** Quantidade de colunas em desktop (lg). Default: 4. */
  columns?: 2 | 3 | 4 | 5 | 6 | 7;
  className?: string;
}

const COLS_LG: Record<2 | 3 | 4 | 5 | 6 | 7, string> = {
  2: 'lg:grid-cols-2',
  3: 'lg:grid-cols-3',
  4: 'lg:grid-cols-4',
  5: 'lg:grid-cols-5',
  6: 'lg:grid-cols-6',
  7: 'lg:grid-cols-7',
};

/** Faixa horizontal de KPI cards com separador inferior. */
export function ListPageKpis({
  children,
  columns = 4,
  className,
}: ListPageKpisProps) {
  return (
    <div
      className={cn(
        'grid grid-cols-2 gap-3 px-4 py-3',
        COLS_LG[columns],
        className,
      )}
    >
      {children}
    </div>
  );
}
